// extracted by mini-css-extract-plugin
export default {"wrapper":"css_wrapper__aDiHU","scrollableContent":"css_scrollableContent__AhOdp","main":"css_main__G7CbN"};